"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../DOM/EventTarget/AddKeyListener");
const EventFilter_1 = require("../../DOM/EventTarget/EventFilter");
const EventListenerManager_1 = require("../../DOM/EventTarget/EventListenerManager");
(() => {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function addEventListener(types, listener, ...options) {
        // add support for multiple events on one listener
        // add support for named listeners (ex: `click.search`)
        // add support for key listener (ex: `keyup:enter`);
        // add support for modifier listener (ex: `ctrl+click`)
        for (let type of types.split(/\s+/)) {
            if (type.includes(':')) {
                const [eventName, keyStroke] = type.split(':');
                this.addKeyListener(keyStroke, listener, eventName);
                return;
            }
            const originalType = type;
            // ctrl/shift/alt modifier
            if (type.includes('+')) {
                // remove the modifiers, last entry is the event type
                const modifiers = type.split('+');
                type = modifiers.pop();
                // update listener
                listener = EventFilter_1.default.filterModifierEvent(modifiers.join('+'), listener);
            }
            // event name modifier
            if (type.includes('.')) {
                type = type.split('.')[0];
            }
            // register this listener, and apply to original function
            EventListenerManager_1.default.getListeners(this).push({ type: originalType, eventName: type, listener });
            originalAddEventListener.apply(this, [type, listener, ...options]);
        }
    };
})();
//# sourceMappingURL=AddEventListener.js.map